import { Moon, Sun } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useTheme } from "@/context/ThemeContext";

export default function ThemeToggle({ className = "", testId = "theme-toggle" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid={testId}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      className={`relative h-10 w-10 flex items-center justify-center border border-[var(--lt-border)] hover:border-[var(--lt-accent)] bg-[var(--lt-panel)] overflow-hidden rounded-xl transition-colors ${className}`}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={theme}
          initial={{ y: -20, opacity: 0, rotate: -90 }}
          animate={{ y: 0, opacity: 1, rotate: 0 }}
          exit={{ y: 20, opacity: 0, rotate: 90 }}
          transition={{ duration: 0.28, ease: "easeOut" }}
          className="flex items-center justify-center"
        >
          {isDark
            ? <Moon className="h-4 w-4 text-[var(--lt-accent-bright)]" />
            : <Sun className="h-4 w-4 text-[var(--lt-accent-bright)]" />}
        </motion.span>
      </AnimatePresence>
    </button>
  );
}
